module.exports = __webpack_public_path__ + "images/topic-screenshots/coral-reef/CU_Scene_Jellyfish_Food.png";